import type { RuVectorSearchResult, RuVectorSource, RuVectorStats } from '@/types/electron';

function getElectronAPI() {
  if (typeof window === 'undefined') return null;
  const api = (window as any).electronAPI;
  if (!api?.isElectron) return null;
  return api;
}

export function isRuVectorAvailable(): boolean {
  const api = getElectronAPI();
  return Boolean(api?.ruvector);
}

export async function ruvectorStats(): Promise<RuVectorStats> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return {
      initialized: false,
      dimensions: 384,
      baseDir: null,
      error: 'RuVector is only available in the desktop app (Electron).',
    };
  }
  return await api.ruvector.stats();
}

export async function ruvectorSearch(params: {
  source: RuVectorSource;
  queryEmbedding: number[];
  limit?: number;
  filters?: any;
}): Promise<{ ok: boolean; results: RuVectorSearchResult[]; error?: string }> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return {
      ok: false,
      results: [],
      error: 'RuVector is only available in the desktop app (Electron).',
    };
  }
  return await api.ruvector.search(params);
}

export async function ruvectorClear(source: RuVectorSource): Promise<{ ok: boolean; error?: string }> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return { ok: false, error: 'RuVector is only available in the desktop app (Electron).' };
  }
  return await api.ruvector.clear({ source });
}

export async function ruvectorIndexStart(scopes: string[]): Promise<{ ok: boolean; error?: string }> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return { ok: false, error: 'RuVector is only available in the desktop app (Electron).' };
  }
  return await api.ruvector.indexStart({ scopes });
}

export async function ruvectorIndexStop(): Promise<{ ok: boolean; error?: string }> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return { ok: false, error: 'RuVector is only available in the desktop app (Electron).' };
  }
  return await api.ruvector.indexStop();
}

export async function ruvectorIndexStatus(): Promise<{ ok: boolean; status: any; error?: string }> {
  const api = getElectronAPI();
  if (!api?.ruvector) {
    return { ok: false, status: null, error: 'RuVector is only available in the desktop app (Electron).' };
  }
  return await api.ruvector.indexStatus();
}
